/* tslint:disable */
/* eslint-disable */
/**
 * backserverv6 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.2-PREVIEW
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface DpeV2Logement {
    'id'?: number;
    'codeIris'?: string;
    'adresse_ban'?: string;
    'adresse_brut'?: string;
    'annee_construction'?: string;
    'appartement_non_visite'?: string;
    'apport_interne_saison_chauffe'?: string;
    'apport_interne_saison_froide'?: string;
    'apport_solaire_saison_chauffe'?: string;
    'apport_solaire_saison_froide'?: string;
    'besoin_chauffage'?: string;
    'besoin_ecs'?: string;
    'besoin_ecs_batiment'?: string;
    'besoin_ecs_logement'?: string;
    'besoin_refroidissement'?: string;
    'categorie_enr'?: string;
    'classe_altitude'?: string;
    'classe_inertie_batiment'?: string;
    'code_departement_ban'?: string;
    'code_insee_ban'?: string;
    'code_postal_ban'?: string;
    'code_postal_brut'?: string;
    'code_region_ban'?: string;
    'complement_adresse_batiment'?: string;
    'complement_adresse_logement'?: string;
    'configuration_installation_chauffage_n1'?: string;
    'configuration_installation_chauffage_n2'?: string;
    'configuration_installation_ecs_n1'?: string;
    'conso_5_usages_ef'?: string;
    'conso_5_usages_ef_energie_n1'?: string;
    'conso_5_usages_ef_energie_n2'?: string;
    'conso_5_usages_par_m2_ef'?: string;
    'conso_5_usages_ef_energie_n3'?: string;
    'conso_5_usages_ep'?: string;
    'conso_5_usages_par_m2_ep'?: string;
    'conso_auxiliaires_ef'?: string;
    'conso_auxiliaires_ep'?: string;
    'conso_chauffage_ef'?: string;
    'conso_chauffage_ef_energie_n1'?: string;
    'conso_chauffage_ef_energie_n2'?: string;
    'conso_chauffage_ef_energie_n3'?: string;
    'conso_chauffage_ep'?: string;
    'conso_chauffage_generateur_n1_installation_n1'?: string;
    'conso_chauffage_generateur_n1_installation_n2'?: string;
    'conso_chauffage_generateur_n2_installation_n1'?: string;
    'conso_chauffage_generateur_n2_installation_n2'?: string;
    'conso_chauffage_installation_chauffage_n1'?: string;
    'conso_chauffage_installation_chauffage_n2'?: string;
    'conso_eclairage_ef'?: string;
    'conso_eclairage_ep'?: string;
    'conso_ecs_ef'?: string;
    'conso_ecs_ef_energie_n1'?: string;
    'conso_ecs_ef_energie_n2'?: string;
    'conso_ecs_ef_energie_n3'?: string;
    'conso_ecs_ep'?: string;
    'conso_ef_generateur_n1_ecs_n1'?: string;
    'conso_ef_generateur_n2_ecs_n1'?: string;
    'conso_ef_installation_ecs_n1'?: string;
    'conso_refroidissement_annuel'?: string;
    'conso_refroidissement_ef'?: string;
    'conso_refroidissement_ep'?: string;
    'coordonnee_cartographique_x_ban'?: number;
    'coordonnee_cartographique_y_ban'?: number;
    'cop_generateur_n1_ecs_n1'?: string;
    'cop_generateur_n2_ecs_n1'?: string;
    'cout_auxiliaires'?: string;
    'cout_chauffage'?: string;
    'cout_chauffage_energie_n1'?: string;
    'cout_chauffage_energie_n2'?: string;
    'cout_chauffage_energie_n3'?: string;
    'cout_eclairage'?: string;
    'cout_ecs'?: string;
    'cout_ecs_energie_n1'?: string;
    'cout_ecs_energie_n2'?: string;
    'cout_ecs_energie_n3'?: string;
    'cout_refroidissement'?: string;
    'cout_total_5_usages'?: string;
    'cout_total_5_usages_energie_n3'?: string;
    'cout_total_5_usages_energie_n1'?: string;
    'cout_total_5_usages_energie_n2'?: string;
    'date_derniere_modification_dpe'?: string;
    'date_etablissement_dpe'?: string;
    'date_fin_validite_dpe'?: string;
    'date_installation_generateur_n1_ecs_n1'?: string;
    'date_installation_generateur_n2_ecs_n1'?: string;
    'date_reception_dpe'?: string;
    'date_visite_diagnostiqueur'?: string;
    'deperditions_baies_vitrees'?: string;
    'deperditions_enveloppe'?: string;
    'deperditions_murs'?: string;
    'deperditions_planchers_bas'?: string;
    'deperditions_planchers_hauts'?: string;
    'deperditions_ponts_thermiques'?: string;
    'deperditions_portes'?: string;
    'deperditions_renouvellement_air'?: string;
    'description_generateur_chauffage_n1_installation_n1'?: string;
    'description_generateur_chauffage_n1_installation_n2'?: string;
    'description_generateur_chauffage_n2_installation_n1'?: string;
    'description_generateur_chauffage_n2_installation_n2'?: string;
    'description_generateur_froid'?: string;
    'description_generateur_n1_ecs_n1'?: string;
    'description_generateur_n2_ecs_n1'?: string;
    'description_installation_chauffage_n1'?: string;
    'description_installation_chauffage_n2'?: string;
    'description_installation_ecs_n1'?: string;
    'electricite_pv_autoconsommee'?: string;
    'emission_ges_5_usages'?: string;
    'emission_ges_5_usages_par_m2'?: string;
    'emission_ges_5_usages_energie_n1'?: string;
    'emission_ges_5_usages_energie_n2'?: string;
    'emission_ges_5_usages_energie_n3'?: string;
    'emission_ges_auxiliaires'?: string;
    'emission_ges_chauffage'?: string;
    'emission_ges_chauffage_energie_n1'?: string;
    'emission_ges_chauffage_energie_n2'?: string;
    'emission_ges_chauffage_energie_n3'?: string;
    'emission_ges_eclairage'?: string;
    'emission_ges_ecs'?: string;
    'emission_ges_ecs_energie_n1'?: string;
    'emission_ges_ecs_energie_n2'?: string;
    'emission_ges_ecs_energie_n3'?: string;
    'emission_ges_refroidissement'?: string;
    'etiquette_dpe'?: string;
    'etiquette_ges'?: string;
    'facteur_couverture_solaire_installation_chauffage_n1'?: string;
    'facteur_couverture_solaire_installation_chauffage_n2'?: string;
    'facteur_couverture_solaire_n1'?: string;
    'facteur_couverture_solaire_saisi_installation_chauffage_n1'?: string;
    'facteur_couverture_solaire_saisi_installation_chauffage_n2'?: string;
    'facteur_couverture_solaire_saisi_n1'?: string;
    'hauteur_sous_plafond'?: string;
    'id_rnb'?: string;
    'identifiant_ban'?: string;
    'indicateur_confort_ete'?: string;
    'inertie_lourde'?: string;
    'isolation_toiture'?: string;
    'logement_traversant'?: string;
    'methode_application_dpe'?: string;
    'modele_dpe'?: string;
    'nom_commune_ban'?: string;
    'nom_commune_brut'?: string;
    'nom_residence'?: string;
    'nom_rue_ban'?: string;
    'nombre_appartement'?: string;
    'nombre_logements_desservis_par_installation_ecs_n1'?: string;
    'nombre_module'?: string;
    'nombre_niveau_immeuble'?: string;
    'nombre_niveau_logement'?: string;
    'numero_dpe'?: string;
    'numero_dpe_immeuble_associe'?: string;
    'numero_dpe_remplace'?: string;
    'numero_etage_appartement'?: string;
    'numero_immatriculation_copropriete'?: string;
    'numero_rpls_logement'?: string;
    'numero_voie_ban'?: string;
    'periode_construction'?: string;
    'periode_installation_generateur_froid'?: string;
    'position_logement_dans_immeuble'?: string;
    'presence_brasseur_air'?: string;
    'presence_production_pv'?: string;
    'production_ecs_solaire_installation_n1'?: string;
    'production_electricite_pv_kwhep_par_an'?: string;
    'protection_solaire_exterieure'?: string;
    'provenance_id_rnb'?: string;
    'qualite_isolation_enveloppe'?: string;
    'qualite_isolation_menuiseries'?: string;
    'qualite_isolation_murs'?: string;
    'qualite_isolation_plancher_bas'?: string;
    'qualite_isolation_plancher_haut_comble_amenage'?: string;
    'qualite_isolation_plancher_haut_comble_perdu'?: string;
    'qualite_isolation_plancher_haut_toit_terrasse'?: string;
    'score_ban'?: string;
    'statut_geocodage'?: string;
    'surface_chauffee_installation_chauffage_n1'?: string;
    'surface_chauffee_installation_chauffage_n2'?: string;
    'surface_climatisee'?: string;
    'surface_habitable_desservie_par_installation_ecs_n1'?: string;
    'surface_habitable_immeuble'?: string;
    'surface_habitable_logement'?: string;
    'surface_tertiaire_immeuble'?: string;
    'surface_totale_capteurs_pv'?: string;
    'surface_ventilee'?: string;
    'systeme_production_electricite_origine_renouvelable'?: string;
    'type_batiment'?: string;
    'type_emetteur_installation_chauffage_n1'?: string;
    'type_emetteur_installation_chauffage_n2'?: string;
    'type_energie_climatisation'?: string;
    'type_energie_generateur_n1_ecs_n1'?: string;
    'type_energie_generateur_n1_installation_n1'?: string;
    'type_energie_generateur_n1_installation_n2'?: string;
    'type_energie_generateur_n2_ecs_n1'?: string;
    'type_energie_generateur_n2_installation_n1'?: string;
    'type_energie_generateur_n2_installation_n2'?: string;
    'type_energie_n1'?: string;
    'type_energie_n2'?: string;
    'type_energie_n3'?: string;
    'type_energie_principale_chauffage'?: string;
    'type_energie_principale_ecs'?: string;
    'type_generateur_chauffage_principal'?: string;
    'type_generateur_chauffage_principal_ecs'?: string;
    'type_generateur_froid'?: string;
    'type_generateur_n1_ecs_n1'?: string;
    'type_generateur_n1_installation_n1'?: string;
    'type_generateur_n1_installation_n2'?: string;
    'type_generateur_n2_ecs_n1'?: string;
    'type_generateur_n2_installation_n1'?: string;
    'type_generateur_n2_installation_n2'?: string;
    'type_installation_chauffage'?: string;
    'type_installation_chauffage_n1'?: string;
    'type_installation_chauffage_n2'?: string;
    'type_installation_ecs'?: string;
    'type_installation_ecs_n1'?: string;
    'type_installation_solaire_n1'?: string;
    'type_ventilation'?: string;
    'typologie_logement'?: string;
    'ubat_w_par_m2_k'?: string;
    'usage_generateur_n1_ecs_n1'?: string;
    'usage_generateur_n1_installation_n1'?: string;
    'usage_generateur_n1_installation_n2'?: string;
    'usage_generateur_n2_ecs_n1'?: string;
    'usage_generateur_n2_installation_n1'?: string;
    'usage_generateur_n2_installation_n2'?: string;
    'ventilation_posterieure_2012'?: string;
    'version_dpe'?: string;
    'volume_stockage_generateur_n1_ecs_n1'?: string;
    'volume_stockage_generateur_n2_ecs_n1'?: string;
    'zone_climatique'?: string;
    'filename'?: string;
}
export interface NewDpeV2Logement {
    'id'?: number;
    'codeIris'?: string;
    'numero_dpe'?: string;
    'date_derniere_modification_dpe'?: string;
    'date_visite_diagnostiqueur'?: string;
    'date_etablissement_dpe'?: string;
    'date_reception_dpe'?: string;
    'date_fin_validite_dpe'?: string;
    'numero_dpe_remplace'?: string;
    'numero_dpe_immeuble_associe'?: string;
    'id_rnb'?: string;
    'provenance_id_rnb'?: string;
    'numero_rpls_logement'?: string;
    'numero_immatriculation_copropriete'?: string;
    'modele_dpe'?: string;
    'version_dpe'?: string;
    'methode_application_dpe'?: string;
    'etiquette_dpe'?: string;
    'etiquette_ges'?: string;
    'classe_altitude'?: string;
    'zone_climatique'?: string;
    'type_batiment'?: string;
    'type_installation_chauffage'?: string;
    'type_installation_ecs'?: string;
    'hauteur_sous_plafond'?: string;
    'nombre_appartement'?: string;
    'nombre_niveau_immeuble'?: string;
    'nombre_niveau_logement'?: string;
    'typologie_logement'?: string;
    'appartement_non_visite'?: string;
    'surface_habitable_immeuble'?: string;
    'surface_habitable_logement'?: string;
    'surface_tertiaire_immeuble'?: string;
    'classe_inertie_batiment'?: string;
    'adresse_ban'?: string;
    'numero_voie_ban'?: string;
    'nom_rue_ban'?: string;
    'nom_commune_ban'?: string;
    'code_postal_ban'?: string;
    'code_insee_ban'?: string;
    'code_departement_ban'?: string;
    'code_region_ban'?: string;
    'identifiant_ban'?: string;
    'coordonnee_cartographique_x_ban'?: number;
    'coordonnee_cartographique_y_ban'?: number;
    'score_ban'?: string;
    'statut_geocodage'?: string;
    'adresse_brut'?: string;
    'nom_commune_brut'?: string;
    'code_postal_brut'?: string;
    'numero_etage_appartement'?: string;
    'position_logement_dans_immeuble'?: string;
    'nom_residence'?: string;
    'complement_adresse_batiment'?: string;
    'complement_adresse_logement'?: string;
    'indicateur_confort_ete'?: string;
    'protection_solaire_exterieure'?: string;
    'logement_traversant'?: string;
    'presence_brasseur_air'?: string;
    'inertie_lourde'?: string;
    'isolation_toiture'?: string;
    'deperditions_totales_batiment'?: string;
    'deperditions_totales_logement'?: string;
    'deperditions_enveloppe'?: string;
    'deperditions_ponts_thermiques'?: string;
    'deperditions_murs'?: string;
    'deperditions_planchers_hauts'?: string;
    'deperditions_planchers_bas'?: string;
    'deperditions_portes'?: string;
    'deperditions_baies_vitrees'?: string;
    'deperditions_renouvellement_air'?: string;
    'qualite_isolation_enveloppe'?: string;
    'qualite_isolation_murs'?: string;
    'qualite_isolation_plancher_haut_comble_amenage'?: string;
    'qualite_isolation_plancher_bas'?: string;
    'qualite_isolation_menuiseries'?: string;
    'ubat_w_par_m2_k'?: string;
    'besoin_chauffage'?: string;
    'besoin_ecs'?: string;
    'besoin_refroidissement'?: string;
    'conso_5_usages_ep'?: string;
    'conso_5_usages_par_m2_ep'?: string;
    'conso_chauffage_ep'?: string;
    'conso_ecs_ep'?: string;
    'conso_refroidissement_ep'?: string;
    'conso_eclairage_ep'?: string;
    'conso_auxiliaires_ep'?: string;
    'conso_5_usages_ef'?: string;
    'conso_5_usages_par_m2_ef'?: string;
    'conso_chauffage_ef'?: string;
    'conso_ecs_ef'?: string;
    'conso_refroidissement_ef'?: string;
    'conso_eclairage_ef'?: string;
    'conso_auxiliaires_ef'?: string;
    'emission_ges_5_usages'?: string;
    'emission_ges_5_usages_par_m2'?: string;
    'emission_ges_chauffage'?: string;
    'emission_ges_ecs'?: string;
    'emission_ges_refroidissement'?: string;
    'emission_ges_eclairage'?: string;
    'emission_ges_auxiliaires'?: string;
    'type_energie_n1'?: string;
    'conso_5_usages_ef_energie_n1'?: string;
    'conso_chauffage_ef_energie_n1'?: string;
    'conso_ecs_ef_energie_n1'?: string;
    'cout_total_5_usages_energie_n1'?: string;
    'cout_chauffage_energie_n1'?: string;
    'cout_ecs_energie_n1'?: string;
    'emission_ges_5_usages_energie_n1'?: string;
    'emission_ges_chauffage_energie_n1'?: string;
    'emission_ges_ecs_energie_n1'?: string;
    'type_energie_n2'?: string;
    'conso_5_usages_ef_energie_n2'?: string;
    'conso_chauffage_ef_energie_n2'?: string;
    'Conso_ecs_ef_energie_n2'?: string;
    'cout_total_5_usages_energie_n2'?: string;
    'cout_chauffage_energie_n2'?: string;
    'cout_ecs_energie_n2'?: string;
    'emission_ges_5_usages_energie_n2'?: string;
    'emission_ges_chauffage_energie_n2'?: string;
    'emission_ges_ecs_energie_n2'?: string;
    'type_energie_n3'?: string;
    'conso_5_usages_ef_energie_n3'?: string;
    'conso_chauffage_ef_energie_n3'?: string;
    'conso_ecs_ef_energie_n3'?: string;
    'cout_total_5_usages_energie_n3'?: string;
    'cout_chauffage_energie_n3'?: string;
    'cout_ecs_energie_n3'?: string;
    'emission_ges_5_usages_energie_n3'?: string;
    'emission_ges_chauffage_energie_n3'?: string;
    'emission_ges_ecs_energie_n3'?: string;
    'cout_total_5_usages'?: string;
    'cout_chauffage'?: string;
    'cout_ecs'?: string;
    'cout_refroidissement'?: string;
    'cout_eclairage'?: string;
    'cout_auxiliaires'?: string;
    'type_energie_principale_chauffage'?: string;
    'type_generateur_chauffage_principal'?: string;
    'type_installation_chauffage_n1'?: string;
    'type_emetteur_installation_chauffage_n1'?: string;
    'configuration_installation_chauffage_n1'?: string;
    'description_installation_chauffage_n1'?: string;
    'conso_chauffage_installation_chauffage_n1'?: string;
    'surface_chauffee_installation_chauffage_n1'?: string;
    'type_generateur_n1_installation_n1'?: string;
    'type_energie_generateur_n1_installation_n1'?: string;
    'usage_generateur_n1_installation_n1'?: string;
    'conso_chauffage_generateur_n1_installation_n1'?: string;
    'type_generateur_n2_installation_n1'?: string;
    'type_energie_generateur_n2_installation_n1'?: string;
    'usage_generateur_n2_installation_n1'?: string;
    'conso_chauffage_generateur_n2_installation_n1'?: string;
    'type_installation_chauffage_n2'?: string;
    'type_emetteur_installation_chauffage_n2'?: string;
    'configuration_installation_chauffage_n2'?: string;
    'description_installation_chauffage_n2'?: string;
    'conso_chauffage_installation_chauffage_n2'?: string;
    'surface_chauffee_installation_chauffage_n2'?: string;
    'type_generateur_n1_installation_n2'?: string;
    'type_energie_generateur_n1_installation_n2'?: string;
    'usage_generateur_n1_installation_n2'?: string;
    'conso_chauffage_generateur_n1_installation_n2'?: string;
    'type_generateur_n2_installation_n2'?: string;
    'type_energie_generateur_n2_installation_n2'?: string;
    'usage_generateur_n2_installation_n2'?: string;
    'conso_chauffage_generateur_n2_installation_n2'?: string;
    'type_energie_principale_ecs'?: string;
    'type_generateur_chauffage_principal_ecs'?: string;
    'besoin_ecs_batiment'?: string;
    'besoin_ecs_logement'?: string;
    'type_installation_ecs_n1'?: string;
    'configuration_installation_ecs_n1'?: string;
    'description_installation_ecs_n1'?: string;
    'conso_ef_installation_ecs_n1'?: string;
    'nombre_logements_desservis_par_installation_ecs_n1'?: string;
    'surface_habitable_desservie_par_installation_ecs_n1'?: string;
    'type_installation_solaire_n1'?: string;
    'production_ecs_solaire_installation_n1'?: string;
    'type_generateur_n1_ecs_n1'?: string;
    'type_energie_generateur_n1_ecs_n1'?: string;
    'usage_generateur_n1_ecs_n1'?: string;
    'description_generateur_n1_ecs_n1'?: string;
    'volume_stockage_generateur_n1_ecs_n1'?: string;
    'cop_generateur_n1_ecs_n1'?: string;
    'conso_ef_generateur_n1_ecs_n1'?: string;
    'type_generateur_n2_ecs_n1'?: string;
    'type_energie_generateur_n2_ecs_n1'?: string;
    'usage_generateur_n2_ecs_n1'?: string;
    'description_generateur_n2_ecs_n1'?: string;
    'volume_stockage_generateur_n2_ecs_n1'?: string;
    'cop_generateur_n2_ecs_n1'?: string;
    'conso_ef_generateur_n2_ecs_n1'?: string;
    'type_ventilation'?: string;
    'surface_ventilee'?: string;
    'ventilation_posterieure_2012'?: string;
    'type_generateur_froid'?: string;
    'description_generateur_froid'?: string;
    'surface_climatisee'?: string;
    'conso_refroidissement_annuel'?: string;
    'categorie_enr'?: string;
    'systeme_production_electricite_origine_renouvelable'?: string;
    'presence_production_pv'?: string;
    'surface_totale_capteurs_pv'?: string;
    'nombre_module'?: string;
    'production_electricite_pv_kwhep_par_an'?: string;
    'electricite_pv_autoconsommee'?: string;
    'filename'?: string;
}
export interface RncData {
    'epci'?: string;
    'commune'?: string;
    'numerodimmatriculation'?: string;
    'datedimmatriculation'?: string;
    'datedeladernieremaj'?: string;
    'typedesyndicbenevoleprofessionnelnonconnu'?: string;
    'identificationdurepresentantlegal'?: string;
    'siretdurepresentantlegal'?: string;
    'codeape'?: string;
    'communedurepresentantlegal'?: string;
    'mandatencoursdanslacopropriete'?: string;
    'datedefinduderniermandat'?: string;
    'nomdusagedelacopropriete'?: string;
    'adressedereference'?: string;
    'numeroetvoieadressedereference'?: string;
    'codepostaladressedereference'?: string;
    'communeadressedereference'?: string;
    'adressecomplementaire1'?: string;
    'adressecomplementaire2'?: string;
    'adressecomplementaire3'?: string;
    'nombredadressescomplementaires'?: number;
    'longitude'?: number;
    'lattiute'?: number;
    'datedureglementdecopropriete'?: string;
    'residenceservice'?: string;
    'syndicatcooperatif'?: string;
    'syndicatprincipalousyndicatsecondaire'?: string;
    'sisecondairendimmatriculationduprincipal'?: string;
    'nombredaslauxquellesestrattachelesyndicatDeCoproprietaires'?: string;
    'nombredafulauxquellesestrattachelesyndicatDeCoproprietaires'?: string;
    'nombredunionsdesyndicatsauxquelles'?: string;
    'nombretotaldelots'?: string;
    'nombretotaldelotsausagedhabitationdebureauxOudeCommerces'?: string;
    'nombredelotsausagedhabitation'?: string;
    'nombredelotsdestationnement'?: string;
    'periodedeconstruction'?: string;
    'referencecadastrale1'?: string;
    'codeinseecommune1'?: string;
    'prefixe1'?: string;
    'section1'?: string;
    'numeroparcelle1'?: string;
    'referencecadastrale2'?: string;
    'codeinseecommune2'?: string;
    'prefixe2'?: string;
    'section2'?: string;
    'numeroparcelle2'?: string;
    'referencecadastrale3'?: string;
    'codeinseecommune3'?: string;
    'prefixe3'?: string;
    'section3'?: string;
    'numeroparcelle3'?: string;
    'nombredeparcellescadastrales'?: string;
    'nom_qp_2015'?: string;
    'code_qp_2015'?: string;
    'nom_qp_2024'?: string;
    'code_qp_2024'?: string;
    'coprodansacv'?: string;
    'coprodanspvd'?: string;
    'codedepdp'?: string;
    'coprodanspdp'?: string;
    'coproaidee'?: string;
    'codeofficielcommune'?: string;
    'nomofficielcommune'?: string;
    'codeofficielarrondissementcommune'?: string;
    'nomofficielarrondissementcommune'?: string;
    'codeofficielepci'?: string;
    'nomofficielepci'?: string;
    'codeofficieldepartement'?: string;
    'nomofficieldepartement'?: string;
    'codeofficielregion'?: string;
    'nomofficielregion'?: string;
}
export interface TerDpeV2Logement {
    'id'?: number;
    'numero_dpe'?: string;
    'date_derniere_modification_dpe'?: string;
    'date_visite_diagnostiqueur'?: string;
    'date_etablissement_dpe'?: string;
    'date_reception_dpe'?: string;
    'date_fin_validite_dpe'?: string;
    'numero_dpe_remplace'?: string;
    'numero_dpe_immeuble_associe'?: string;
    'id_rnb'?: string;
    'provenance_id_rnb'?: string;
    'numero_immatriculation_copropriete'?: string;
    'modele_dpe'?: string;
    'version_dpe'?: string;
    'methode_dpe'?: string;
    'categorie_erp'?: string;
    'secteur_activite'?: string;
    'etiquette_dpe'?: string;
    'etiquette_ges'?: string;
    'annee_construction'?: string;
    'periode_construction'?: string;
    'surface_shon'?: string;
    'surface_utile'?: string;
    'nombre_occupant'?: string;
    'adresse_ban'?: string;
    'numero_voie_ban'?: string;
    'nom_rue_ban'?: string;
    'nom_commune_ban'?: string;
    'code_postal_ban'?: string;
    'code_insee_ban'?: string;
    'code_departement_ban'?: string;
    'code_region_ban'?: string;
    'identifiant_ban'?: string;
    'coordonnee_cartographique_x_ban'?: number;
    'coordonnee_cartographique_y_ban'?: number;
    'score_ban'?: string;
    'statut_geocodage'?: string;
    'adresse_brut'?: string;
    'nom_commune_brut'?: string;
    'code_postal_brut'?: string;
    'numero_etage_appartement'?: string;
    'nom_residence'?: string;
    'complement_adresse_batiment'?: string;
    'complement_adresse_logement'?: string;
    'conso_kwhep_m2_an'?: string;
    'emission_ges_kg_co2_m2_an'?: string;
    'type_energie_principale_chauffage'?: string;
    'type_energie_n1'?: string;
    'type_usage_energie_n1'?: string;
    'conso_ep_energie_n1'?: string;
    'conso_ef_energie_n1'?: string;
    'frais_annuel_energie_n1'?: string;
    'annee_releve_conso_energie_n1'?: string;
    'type_energie_n2'?: string;
    'type_usage_energie_n2'?: string;
    'conso_ep_energie_n2'?: string;
    'conso_ef_energie_n2'?: string;
    'frais_annuel_energie_n2'?: string;
    'annee_releve_conso_energie_n2'?: string;
    'type_energie_n3'?: string;
    'type_usage_energie_n3'?: string;
    'conso_ep_energie_n3'?: string;
    'conso_ef_energie_n3'?: string;
    'frais_annuel_energie_n3'?: string;
    'annee_releve_conso_energie_n3'?: string;
    'filename'?: string;
    'codeIris'?: string;
}

/**
 * APIV6Api - axios parameter creator
 */
export const APIV6ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Bdnb
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6BdnbGet: async (iris?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/bdnb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iris !== undefined) {
                localVarQueryParameter['iris'] = iris;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bdnbdpe
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6BdnbdpeGet: async (iris?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/bdnbdpe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iris !== undefined) {
                localVarQueryParameter['iris'] = iris;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Insee Dpe V 2 Ter
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6CodeinseeDpvTerGet: async (insee?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/codeinsee/dpvTer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (insee !== undefined) {
                localVarQueryParameter['insee'] = insee;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Insee Dpe V 2
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6CodeinseeDpve2Get: async (insee?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/codeinsee/dpve2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (insee !== undefined) {
                localVarQueryParameter['insee'] = insee;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Insee Shape
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6CodeinseeShapeGet: async (insee?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/codeinsee/shape`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (insee !== undefined) {
                localVarQueryParameter['insee'] = insee;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Dpe New
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6DpvNewGet: async (iris?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/dpvNew`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iris !== undefined) {
                localVarQueryParameter['iris'] = iris;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Dpe Ter
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6DpvTerGet: async (iris?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/dpvTer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iris !== undefined) {
                localVarQueryParameter['iris'] = iris;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Dpe V 2
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6Dpve2Get: async (iris?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/dpve2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iris !== undefined) {
                localVarQueryParameter['iris'] = iris;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Shape
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6ShapeGet: async (iris?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/shape`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iris !== undefined) {
                localVarQueryParameter['iris'] = iris;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Stats
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6StatsGet: async (iris?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v6/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iris !== undefined) {
                localVarQueryParameter['iris'] = iris;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APIV6Api - functional programming interface
 */
export const APIV6ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APIV6ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Bdnb
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6BdnbGet(iris?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6BdnbGet(iris, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6BdnbGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bdnbdpe
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6BdnbdpeGet(iris?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6BdnbdpeGet(iris, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6BdnbdpeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Insee Dpe V 2 Ter
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6CodeinseeDpvTerGet(insee?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerDpeV2Logement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6CodeinseeDpvTerGet(insee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6CodeinseeDpvTerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Insee Dpe V 2
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6CodeinseeDpve2Get(insee?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DpeV2Logement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6CodeinseeDpve2Get(insee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6CodeinseeDpve2Get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Insee Shape
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6CodeinseeShapeGet(insee?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6CodeinseeShapeGet(insee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6CodeinseeShapeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Dpe New
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6DpvNewGet(iris?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewDpeV2Logement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6DpvNewGet(iris, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6DpvNewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Dpe Ter
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6DpvTerGet(iris?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerDpeV2Logement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6DpvTerGet(iris, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6DpvTerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Dpe V 2
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6Dpve2Get(iris?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DpeV2Logement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6Dpve2Get(iris, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6Dpve2Get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Shape
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6ShapeGet(iris?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6ShapeGet(iris, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6ShapeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Stats
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v6StatsGet(iris?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v6StatsGet(iris, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIV6Api.v6StatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * APIV6Api - factory interface
 */
export const APIV6ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APIV6ApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Bdnb
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6BdnbGet(iris?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v6BdnbGet(iris, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bdnbdpe
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6BdnbdpeGet(iris?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v6BdnbdpeGet(iris, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Insee Dpe V 2 Ter
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6CodeinseeDpvTerGet(insee?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TerDpeV2Logement>> {
            return localVarFp.v6CodeinseeDpvTerGet(insee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Insee Dpe V 2
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6CodeinseeDpve2Get(insee?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DpeV2Logement>> {
            return localVarFp.v6CodeinseeDpve2Get(insee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Insee Shape
         * @param {string} [insee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6CodeinseeShapeGet(insee?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v6CodeinseeShapeGet(insee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Dpe New
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6DpvNewGet(iris?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NewDpeV2Logement>> {
            return localVarFp.v6DpvNewGet(iris, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Dpe Ter
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6DpvTerGet(iris?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TerDpeV2Logement>> {
            return localVarFp.v6DpvTerGet(iris, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Dpe V 2
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6Dpve2Get(iris?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DpeV2Logement>> {
            return localVarFp.v6Dpve2Get(iris, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Shape
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6ShapeGet(iris?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v6ShapeGet(iris, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Stats
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v6StatsGet(iris?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.v6StatsGet(iris, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * APIV6Api - object-oriented interface
 */
export class APIV6Api extends BaseAPI {
    /**
     * 
     * @summary Get Bdnb
     * @param {string} [iris] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6BdnbGet(iris?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6BdnbGet(iris, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bdnbdpe
     * @param {string} [iris] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6BdnbdpeGet(iris?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6BdnbdpeGet(iris, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Insee Dpe V 2 Ter
     * @param {string} [insee] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6CodeinseeDpvTerGet(insee?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6CodeinseeDpvTerGet(insee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Insee Dpe V 2
     * @param {string} [insee] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6CodeinseeDpve2Get(insee?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6CodeinseeDpve2Get(insee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Insee Shape
     * @param {string} [insee] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6CodeinseeShapeGet(insee?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6CodeinseeShapeGet(insee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Dpe New
     * @param {string} [iris] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6DpvNewGet(iris?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6DpvNewGet(iris, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Dpe Ter
     * @param {string} [iris] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6DpvTerGet(iris?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6DpvTerGet(iris, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Dpe V 2
     * @param {string} [iris] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6Dpve2Get(iris?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6Dpve2Get(iris, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Shape
     * @param {string} [iris] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6ShapeGet(iris?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6ShapeGet(iris, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Stats
     * @param {string} [iris] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v6StatsGet(iris?: string, options?: RawAxiosRequestConfig) {
        return APIV6ApiFp(this.configuration).v6StatsGet(iris, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BdnbApiApi - axios parameter creator
 */
export const BdnbApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary New Bdnb 2a
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbByBanId2aGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/byBanId2a`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary New Bdnb 2
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbByBanId2bGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/byBanId2b`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary New Bdnb
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbByBanIdGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/byBanId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bdnb By Group
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbByBatGroupIdGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/byBatGroupId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bansiris Periode Construction
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisConstructionGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/iris/construction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bansiris Dpe V 1
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisDpev1Get: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/iris/dpev1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bansiris
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/iris`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bansiris Proprietaire
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisProprietaireGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/iris/proprietaire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Iris Stats
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisStatsGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/iris/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bansiris Surface
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisSurfaceGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/iris/surface`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bansiris Type
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisTypeGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/iris/type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bdnbneighbors
         * @param {string} [cle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbNeighborsGet: async (cle?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/neighbors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cle !== undefined) {
                localVarQueryParameter['cle'] = cle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Syntheses Ban Id
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbSynthesesBanIdGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/synthesesBanId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Syntheses By Code Insee
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbSynthesesByCodeInseeGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/synthesesByCodeInsee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Syntheses By Iris
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbSynthesesByIrisGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bdnb/synthesesByIris`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BdnbApiApi - functional programming interface
 */
export const BdnbApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BdnbApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary New Bdnb 2a
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbByBanId2aGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbByBanId2aGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbByBanId2aGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary New Bdnb 2
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbByBanId2bGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbByBanId2bGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbByBanId2bGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary New Bdnb
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbByBanIdGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbByBanIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbByBanIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bdnb By Group
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbByBatGroupIdGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<{ [key: string]: string; }>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbByBatGroupIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbByBatGroupIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bansiris Periode Construction
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbIrisConstructionGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbIrisConstructionGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbIrisConstructionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bansiris Dpe V 1
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbIrisDpev1Get(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbIrisDpev1Get(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbIrisDpev1Get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bansiris
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbIrisGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbIrisGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbIrisGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bansiris Proprietaire
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbIrisProprietaireGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbIrisProprietaireGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbIrisProprietaireGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Iris Stats
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbIrisStatsGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbIrisStatsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbIrisStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bansiris Surface
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbIrisSurfaceGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbIrisSurfaceGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbIrisSurfaceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bansiris Type
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbIrisTypeGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbIrisTypeGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbIrisTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bdnbneighbors
         * @param {string} [cle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbNeighborsGet(cle?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbNeighborsGet(cle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbNeighborsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Syntheses Ban Id
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbSynthesesBanIdGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbSynthesesBanIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbSynthesesBanIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Syntheses By Code Insee
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbSynthesesByCodeInseeGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbSynthesesByCodeInseeGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbSynthesesByCodeInseeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Syntheses By Iris
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bdnbSynthesesByIrisGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bdnbSynthesesByIrisGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BdnbApiApi.bdnbSynthesesByIrisGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BdnbApiApi - factory interface
 */
export const BdnbApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BdnbApiApiFp(configuration)
    return {
        /**
         * 
         * @summary New Bdnb 2a
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbByBanId2aGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.bdnbByBanId2aGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary New Bdnb 2
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbByBanId2bGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.bdnbByBanId2bGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary New Bdnb
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbByBanIdGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.bdnbByBanIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bdnb By Group
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbByBatGroupIdGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<{ [key: string]: string; }>; }> {
            return localVarFp.bdnbByBatGroupIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bansiris Periode Construction
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisConstructionGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.bdnbIrisConstructionGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bansiris Dpe V 1
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisDpev1Get(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.bdnbIrisDpev1Get(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bansiris
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.bdnbIrisGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bansiris Proprietaire
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisProprietaireGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.bdnbIrisProprietaireGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Iris Stats
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisStatsGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bdnbIrisStatsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bansiris Surface
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisSurfaceGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.bdnbIrisSurfaceGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bansiris Type
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbIrisTypeGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.bdnbIrisTypeGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bdnbneighbors
         * @param {string} [cle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbNeighborsGet(cle?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bdnbNeighborsGet(cle, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Syntheses Ban Id
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbSynthesesBanIdGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bdnbSynthesesBanIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Syntheses By Code Insee
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbSynthesesByCodeInseeGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bdnbSynthesesByCodeInseeGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Syntheses By Iris
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bdnbSynthesesByIrisGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bdnbSynthesesByIrisGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BdnbApiApi - object-oriented interface
 */
export class BdnbApiApi extends BaseAPI {
    /**
     * 
     * @summary New Bdnb 2a
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbByBanId2aGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbByBanId2aGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary New Bdnb 2
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbByBanId2bGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbByBanId2bGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary New Bdnb
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbByBanIdGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbByBanIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bdnb By Group
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbByBatGroupIdGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbByBatGroupIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bansiris Periode Construction
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbIrisConstructionGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbIrisConstructionGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bansiris Dpe V 1
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbIrisDpev1Get(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbIrisDpev1Get(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bansiris
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbIrisGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbIrisGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bansiris Proprietaire
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbIrisProprietaireGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbIrisProprietaireGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Iris Stats
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbIrisStatsGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbIrisStatsGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bansiris Surface
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbIrisSurfaceGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbIrisSurfaceGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bansiris Type
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbIrisTypeGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbIrisTypeGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bdnbneighbors
     * @param {string} [cle] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbNeighborsGet(cle?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbNeighborsGet(cle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Syntheses Ban Id
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbSynthesesBanIdGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbSynthesesBanIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Syntheses By Code Insee
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbSynthesesByCodeInseeGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbSynthesesByCodeInseeGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Syntheses By Iris
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bdnbSynthesesByIrisGet(id?: string, options?: RawAxiosRequestConfig) {
        return BdnbApiApiFp(this.configuration).bdnbSynthesesByIrisGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RncApiApi - axios parameter creator
 */
export const RncApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Data By Code
         * @param {string} [param] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rncGet: async (param?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rnc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (param !== undefined) {
                localVarQueryParameter['param'] = param;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Data By Insee
         * @param {string} [param] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rncInseeGet: async (param?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rnc/insee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (param !== undefined) {
                localVarQueryParameter['param'] = param;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RncApiApi - functional programming interface
 */
export const RncApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RncApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Data By Code
         * @param {string} [param] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rncGet(param?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RncData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rncGet(param, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RncApiApi.rncGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Data By Insee
         * @param {string} [param] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rncInseeGet(param?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RncData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rncInseeGet(param, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RncApiApi.rncInseeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RncApiApi - factory interface
 */
export const RncApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RncApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Data By Code
         * @param {string} [param] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rncGet(param?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RncData>> {
            return localVarFp.rncGet(param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Data By Insee
         * @param {string} [param] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rncInseeGet(param?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RncData>> {
            return localVarFp.rncInseeGet(param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RncApiApi - object-oriented interface
 */
export class RncApiApi extends BaseAPI {
    /**
     * 
     * @summary Get Data By Code
     * @param {string} [param] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rncGet(param?: string, options?: RawAxiosRequestConfig) {
        return RncApiApiFp(this.configuration).rncGet(param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Data By Insee
     * @param {string} [param] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rncInseeGet(param?: string, options?: RawAxiosRequestConfig) {
        return RncApiApiFp(this.configuration).rncInseeGet(param, options).then((request) => request(this.axios, this.basePath));
    }
}



